(function($, Drupal) {
  /* Search params from url */
  let searchParams = new URLSearchParams(window.location.search);

  /* Check if parameter "registration-complete" has value 1 */
  if (searchParams.get("registration-complete") === "1") {
    $(".content").prepend(
      '<div role="contentinfo" aria-label="Status message" class="after-redirect-messages-status messages messages--status">\n' +
        '<h2 class="visually-hidden">Status message</h2>\n' +
        "A welcome message with further instructions has been sent to your email address.\n" +
        "</div>"
    );
  } else {
    $(".after-redirect-messages-status").remove();
  }
  Drupal.behaviors.ecommerceChange = {
    attach: function(context, settings) {
      $(
        ".commerce-order-item-add-to-cart-form .ecommerce__selected-variation",
        context
      )
        .once("cart-processed")
        .each(function() {
          $(this)
            .next(".field--name-purchased-entity")
            .addBack()
            .wrapAll("<div class='ecommerce__size_wrap' />");
        });
      $(
        ".commerce-order-item-add-to-cart-form .field--type-commerce-price",
        context
      )
        .once("price-processed")
        .each(function() {
          $(this)
            .next(".js-form-wrapper")
            .addBack()
            .wrapAll("<div class='ecommerce__price_wrap' />");
        });

      if ($(".lifestyle--C")) {
        $(".lifestyle--C .lifestyle__heading").prependTo($(".lifestyle--C"));
      }
      if (
        $(".back-js-wrapper") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".back-js-wrapper  .layout__region--second").prependTo(
          $(".back-js-wrapper .card__text")
        );
      }
      if (
        $('.cardgrid--C[data-class="nomorelimitscardgrid"]') &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".cardgrid--C  .layout__region--second").prependTo(
          $('.cardgrid--C[data-class="nomorelimitscardgrid"] .card__text')
        );
      }
      if (
        $(".about-lifestyle") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".about-lifestyle").after($(".about-lifestyle .lifestyle__text"));
      }
      if (
        $(".about-us-js-helper") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".about-us-js-helper .card__text h3").after(
          $(".about-us-js-helper .layout__region--second")
        );
      }
      if (
        $(".about-us-js-helper-2") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".about-us-js-helper-2 .card__text h3").after(
          $(".about-us-js-helper-2 .layout__region--first")
        );
      }
      if (
        $(".cardgrid-js-helper") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".cardgrid-js-helper").once().each(function () {
          var $this = $(this);
          var $firstRegion = $this.find(".layout__region--first");
          var $secondRegion = $this.find(".layout__region--second");

          if ($secondRegion.find(".card__picture").length) {
            $this.find(".card__heading").after(
              $secondRegion
            );
          } else if ($firstRegion.find(".card__picture").length) {
            $this.find(".card__heading").after(
              $firstRegion
            );
          }
        });
      }
      if (
        $(".lily-js-helper") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".lily-js-helper .card__heading").after(
          $(".lily-js-helper .layout__region--second")
        );
      }
      if (
        $(".lily-js-helper2") &&
        window.matchMedia("(max-width: 767px)").matches
      ) {
        $(".lily-js-helper2 .card__heading").after(
          $(".lily-js-helper2 .layout__region--second")
        );
      }
      if ($(".bff-js") && window.matchMedia("(max-width: 767px)").matches) {
        $(".bff-js .card__text")
          .children("p")
          .eq(0)
          .after($(".bff-js .layout__region--second"));
      }
    }
  };
  function lifestyleMarkupChanger() {
    if ($(".lifestyle--I") && window.matchMedia("(max-width: 767px)").matches) {
      var detachText = $(".lifestyle--I .lifestyle__text").detach();
      detachText.addClass("lifestyle--text--bellow");
      detachText - $(".lifestyle--I .lifestyle__wrap").after(detachText);
    } else if (
      $(".lifestyle--I .lifestyle__text").hasClass("lifestyle--text--bellow")
    ) {
      var attachText = $(".lifestyle--I .lifestyle__text").detach();
      attachText.removeClass("lifestyle--text--bellow");
      attachText - $(".lifestyle--I .lifestyle__heading").after(attachText);
    }
  }

  Drupal.behaviors.lifestyleMarkup = {
    attach: function(context) {
      $(".lifestyle--I", context)
        .once("lifestyle-processed")
        .each(function() {
          lifestyleMarkupChanger();
          $(window).resize(function() {
            lifestyleMarkupChanger();
          });
        });
    }
  };

  Drupal.behaviors.promobarWidth = {
    attach: function(context, settings) {
      var promoTop = $(".promobar-top p");
      var promoBottom = $(".promobar-bottom p");
      var promoTopWidth = $(".promobar-top p").width();
      var promoBottomWidth = $(".promobar-bottom p").width();

      if (promoTopWidth > promoBottomWidth) {
        promoBottom.css({ width: promoTopWidth + "px" });
      } else {
        promoTop.css({ width: promoBottomWidth + "px" });
      }
    }
  };

  Drupal.behaviors.ecommerceButtonScroll = {
    attach: function(context) {
      $(context)
        .find(".ecommerce-button-js")
        .once("ecommerce-button-processed")
        .each(function() {
          $(this)
            .find(".lifestyle__btn")
            .click(function(e) {
              e.preventDefault();
              $("html,body").animate(
                {
                  scrollTop: $(".ecommerce").offset().top
                },
                "slow"
              );
            });
        });
    }
  };

  // promobar infinite text
  let promobar = $(".promobar__wrapper");

  promobar.each(function(i, bar) {
    let marquee = $(bar).find(".marquee");
    let paragraph = marquee.html();
    let parentWidth = $(bar).width();
    let marqueeWidth = marquee.width();

    let iterationCount = Math.ceil((parentWidth / marqueeWidth) * 3.5);

    for (let i = 0; i <= iterationCount; i++) {
      marquee.append(paragraph);
    }
    marquee.append(paragraph);
  });

  Drupal.behaviors.iOSModalScroll = {
    attach: function(context, settings) {
      if (window.innerWidth <= 1024) {
        $(".nav__list").on("scroll", function() {
          if (this.scrollTop === 0) {
            // element is at the top of its scroll position, so scroll 1 pixel down
            this.scrollTop = 1;
          }

          if (this.scrollHeight - this.scrollTop === this.clientHeight) {
            // element is at the bottom of its scroll position, so scroll 1 pixel up
            this.scrollTop -= 1;
          }
        });
      }
    }
  };

  Drupal.behaviors.promoblockSliderDots = {
    attach: function(context, settings) {
      moveSlickDots($(".slick-current"));

      $(".slider").on("afterChange", function(
        event,
        slick,
        currentSlide,
        nextSlide
      ) {
        var title = $(slick.$slider[0]).find(".slick-current");
        moveSlickDots(title);
      });
    }
  };

  function moveSlickDots(title) {
    var dots = $(".slider--D .slick-dots");

    if (title.length) {
      title = title.find(".promo-block__heading-mobile");
    }

    if (dots && title && window.innerWidth <= 768) {
      var offset = parseInt(title.css("height"), 10) + 80 + "px"; // 70px to compensate for wrapper padding
      dots.css("top", offset);
    }
  }

  Drupal.behaviors.sliderE = {
    attach: () => {
      /**
       * Move slick dots to a new position related to "mobile heading" element of a slide.
       * @param {object} slide - jquery element - "slick-slide" element.
       */
      const moveDots = (slide) => {
        const slider = slide.closest('.slick-slider');
        const dots = slider.find('.slick-dots');

        if ($(window).width() < 768) {
          const sliderOffsetTop = slider.offset().top;
          const mobileHeadingOffsetTop = slide.find('[class*=heading-mobile]').offset().top;
          let allMobHeadingHeights = [];
          let maxMobHeadingVal;

          // Get the height of the highest mobile heading:
          slider.find('[class*=heading-mobile]').each((indMH, mobHeading) => {
            allMobHeadingHeights.push(parseInt($(mobHeading).find('> h3').height(), 10));
          });
          maxMobHeadingVal = Math.max(...allMobHeadingHeights);
          // Set all mobile heading's height = the highest one:
          slider.find('[class*=heading-mobile]').height(maxMobHeadingVal);
          // Set dots' position:
          dots.css({
            top: mobileHeadingOffsetTop - sliderOffsetTop + maxMobHeadingVal + 'px',
            bottom: 'auto',
          });
        } else {
          dots.css({
            top: '',
            bottom: '',
          });
        }
      };

      $('.slider.slider--E').each((ind, elm) => {
        const $this = $(elm);
        if (!$this.find('[class*=heading-mobile]').length || !$this.find('.slick-dots').length) return false;

        moveDots($this.find('.slick-current')); // 1st run;
        // Slick slowly changes slide width, so must wait a bit and run function again:
        setTimeout(() => {
          moveDots($this.find('.slick-current'));
        }, 500);

        $this.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
          moveDots($this.find(`[data-slick-index="${nextSlide}"]`));
        });

        $(window).on('resize', () => {
          moveDots($this.find('.slick-current'));
          // Slick slowly changes slide width, so must wait a bit and run function again:
          setTimeout(() => {
            moveDots($this.find('.slick-current'));
          }, 500);
        });
      });
    }
  };

  // Change image on select variation inside modal
  Drupal.behaviors.modalBundles = {
    attach: function (context, settings) {
      $("input[id^='edit-purchased-entity-0-bundle-variations-ref-options']").next('label').click(function(){
        var value = $( this ).prev('input').val();
        $(this).parents('.fieldset-inner').find('div[class^="product-variation-"]').hide();
        $(this).parents('.fieldset-inner').find('.product-variation-' + value).show();
      });
    }
  }

  // modal

  var modalOpen = $(".buy-now-button > a");
  var modalClose = $(".close-button");
  var modalOverlay = $('<div class="modal-overlay closed"></div>');
  var bundlePage = $(".path-product-bundles");
  var bundleModal = $(".bundle-variation-wrapper");
  bundleModal.detach();
  bundlePage.append(bundleModal);
  bundlePage.append(modalOverlay);

  modalOpen.on("click", function() {
    bundleModal.toggleClass("closed");
    modalOverlay.toggleClass("closed");
    $('body').toggleClass('modal-open');

    $("[class*='-bundle-variations-ref-options']").on("click", function() {
      $(this)
        .closest("fieldset")
        .find("input")
        .attr("checked", false);
      $(this)
        .find("input")
        .attr("checked", true);
    });
  });

  modalClose.on("click", function() {
    bundleModal.toggleClass("closed");
    modalOverlay.toggleClass("closed");
    $('body').toggleClass('modal-open');
  });

  // discover more bundles class
  var cardGrid = $('[data-class="discovermorecardgrid"]');

  if (cardGrid.length) {
    cardGrid
      .find(".card__bundle-wrap")
      .closest(".layout__region")
      .addClass("bundle-card");
  }

  Drupal.behaviors.stripeButtonClass = {
    attach: function(context, settings) {
      if($('body').hasClass('path-cart')) {

        if(
          !$("#payment-request-button").length
          || !$("#payment-request-button").find('iframe')
        ) {
          return;
        }

        let pgClass = '';
        let pgBtn = '<span class="pg-btn">' + Drupal.t('Pay with ') + '</span>';

        if(window.ApplePaySession) { // check if apple pay
          pgClass = 'apple-pay';
        } else {
          if(window.PaymentRequest) { // check if google pay
            pgClass = 'google-pay';
          } else {
            return;
          }
        }

        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              if($('.__PrivateStripeElement').length > 0) {
                $('.__PrivateStripeElement').appendTo('.cart__actions #stripe-payment-request-setup-wrapper #payment-request-button');
                let sidebarStripe = $('.cart__actions #stripe-payment-request-setup-wrapper');
                sidebarStripe.addClass(pgClass).once().append(pgBtn);
                observer.disconnect();
              }
          });
        });

        var config = {childList: true, subtree: true};
        observer.observe($('.cart__form #stripe-payment-request-setup-wrapper')[0], config);
      }
    }
  };
})(jQuery, Drupal);
